import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import SidebarDownloadDocButton from 'RankBrain2SidebarNavbar/SidebarDownloadSection/SidebarDownloadDocButton';

const RankBrain3LandingDownloadSection = props => (
  <div
    className="rank-brain-3-landing-download-section-container section-container"
  >
    <div className="rank-brain-3-download-doc-container">
      <div className="download-label">Word</div>
      <SidebarDownloadDocButton
        slug={props.slug}
        imgSrc="/images/rank-brain-3/download-word-2x.png"
        imgSrcHover="/images/rank-brain-3/download-word-hover-2x.png"
        text=""
        format="docx"
      />
    </div>
    <div className="rank-brain-3-download-doc-container">
      <div className="download-label">PDF</div>
      <SidebarDownloadDocButton
        slug={props.slug}
        imgSrc="/images/rank-brain-3/download-pdf-2x.png"
        imgSrcHover="/images/rank-brain-3/download-pdf-hover-2x.png"
        text=""
        format="pdf"
      />
    </div>
  </div>
);

RankBrain3LandingDownloadSection.init = (id, props) => {
  ReactDOM.render(
    <RankBrain3LandingDownloadSection {...props} />,
    document.getElementById(id),
  );
};

export default RankBrain3LandingDownloadSection;

RankBrain3LandingDownloadSection.propTypes = {
  slug: PropTypes.string.isRequired,
};



// WEBPACK FOOTER //
// ./src-react/RankBrain3LandingDownloadSection/index.jsx